/**
 * HiddenObjectListWidget - Hides object_list fields in sidebar
 *
 * Object list items (like facets, slides, rows) are edited by clicking them
 * in the preview iframe. This widget hides the accordion UI in the sidebar.
 */
const HiddenObjectListWidget = () => {
  // Return null - items are edited via iframe selection
  return null;
};

export default HiddenObjectListWidget;
